import { apiSlice } from './apiSlice';
export const paymentSetupsApi = apiSlice.injectEndpoints({ endpoints: builder => ({
  getPaymentSetups: builder.query({ query: () => '/api/payment-setups' }),
}) });
export const { useGetPaymentSetupsQuery } = paymentSetupsApi;
